









































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { normalize, cummulativeSum } from '../utils/stats';

const colors = [
  "#F93E3B",
  "#0D51E6",
  "#EF3BF3",
  "#FDA400",
];

@Component
export default class Roulette extends Vue {
  @Prop() slices!: number[];
  @Prop({ default: -25 }) offset!: number;
  @Prop({ default: []}) labels!: string[];
  rotate = 0;
  winnerIndex = -1;
  timeout: null | number = null;

  get normalizedSlices() {
    return normalize(this.slices);
  }

  get cummulativeSlices() {
    return cummulativeSum(this.normalizedSlices);
  }

  @Watch('slices')
  slicesChanged() {
    this.winnerIndex = -1;
  }

  get totalLabels() {
    const labels = [...this.labels];
    const missing = this.slices.length - labels.length;
    if (missing > 0) {
      labels.push(...[...Array(missing).keys()].map(a => `${a + 1 + labels.length}`))
    }
    return labels;
  }

  get sliceAttributes() {
    const sliceAttributes = [];
    let dashOffset = 0;
    let index = 0;
    for (const slice of this.normalizedSlices) {
      const isSameColorAsFirst = this.slices.length % colors.length === 1 && index === this.slices.length - 1;
      const color = isSameColorAsFirst ? colors[1] : colors[index % colors.length];
      sliceAttributes.push({
        index,
        slice,
        dashOffset: 1 - dashOffset,
        labelOffset: (0.5 + dashOffset + slice/2) % 1,
        color,
      });
      dashOffset += slice;
      index += 1;
    }
    return sliceAttributes;
  }

  spin() {
    this.winnerIndex = -1;
    const winner = Math.random();
    const winnerIndex = this.cummulativeSlices.findIndex(probability => winner < probability);
    console.log({ slices: this.cummulativeSlices, winner, winnerIndex, name: this.totalLabels[winnerIndex] });
    this.rotate = Math.ceil(this.rotate / 360) * 360 +  (1-winner) * 360 + 360 * 10;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.winnerIndex = winnerIndex;
    }, 9600);
  }
}
